import React, { useEffect, useState, useContext } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import { authAPI } from '../api';

export default function DiscordCallbackPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { loginWithToken } = useContext(AuthContext);
  const [error, setError] = useState('');

  useEffect(() => {
    const run = async () => {
    const token = searchParams.get('token');
    const userB64 = searchParams.get('user');
    const errorParam = searchParams.get('error');

    if (errorParam) {
      setError(decodeURIComponent(errorParam));
      return;
    }

    if (!token || !userB64) {
      setError('Connexion Discord échouée — données manquantes');
      return;
    }

    try {
      const user = JSON.parse(atob(userB64));
      loginWithToken(token, user);

      // Récupérer et accepter automatiquement une invitation en attente
      const pendingInviteToken = sessionStorage.getItem('pendingInviteToken');
      if (pendingInviteToken) {
        sessionStorage.removeItem('pendingInviteToken');
        try {
          await authAPI.acceptInvitation(pendingInviteToken);
        } catch (e) {
          console.warn('Auto-claim invitation échoué:', e.message);
        }
      }

      const isNewUser = searchParams.get('isNewUser') === '1';
      if (isNewUser && user.needsEmail) {
        navigate('/profile?setup=1');
      } else {
        navigate('/dashboard');
      }
    } catch (e) {
      setError('Erreur lors de la connexion Discord');
    }
    };
    run();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', gap: '1rem' }}>
        <p style={{ color: '#ef4444', fontSize: '1.1rem' }}>❌ {error}</p>
        <button className="submit-button" style={{ maxWidth: 260 }} onClick={() => navigate('/riot-login')}>
          Retour à la connexion
        </button>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
      <p style={{ color: '#9ca3af', fontSize: '1.1rem' }}>Connexion avec Discord en cours...</p>
    </div>
  );
}
